import Actions from '../../odata/actions';

const actions = new Actions('timeSheetDocument', 'timeSheetDocuments');

export default actions;
